/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "amzlradrepairreceive",
            "endpoint": "https://mgzlk9uka9.execute-api.us-east-1.amazonaws.com/uat",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
